import {
  Links,
  LiveReload,
  Meta,
  Outlet,
  Scripts,
  ScrollRestoration,
} from "@remix-run/react";
import { GlobalStyles } from "./global/styles";
import type { MetaFunction } from "@remix-run/node";

// alteração tese

export const meta: MetaFunction = () => ({
  charset: "utf-8",
  viewport: "width=device-width,initial-scale=1",
});

export function links() {
  return [
    { rel: "preconnect", href: "https://fonts.gstatic.com" },
    { rel: "preconnect", href: "https://fonts.googleapis.com" },
    {
      rel: "stylesheet",
      href: "https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700&display=swap",
    },
  ];
}

export default function App() {
  return (
    <html lang="pt-br">
      <head>
        <Meta />
        <Links />
        {typeof document === "undefined" ? "__STYLES__" : null}
      </head>
      <body>
        <Outlet />
        <ScrollRestoration />
        <Scripts />
        <LiveReload />
        <GlobalStyles />
        <script
          src="https://maps.googleapis.com/maps/api/js?key=AIzaSyC2MXl11fUCg3YMABQVxZylrU1ZINGjrp0&libraries=places&callback=initMap"
          async
        ></script>
      </body>
    </html>
  );
}
